import Box from '@mui/material/Box'
import {Select, Text} from '../../1elements'

const ContactImportTypeDropdown = ({value, onChange, disabled, validation}) => {
    const options = ['Add new/assign existing contact', 'Add multiple contacts'];

    return(
        <Box sx={{ maxWidth: '400px' }}>
            <Text type={'fieldLabel'}>Select an option to add<span className={'requiredAsterisk'} >*</span></Text>
            <Select options={options} helperText={'Select One'} value={value} onChange={onChange}
                    disabled={disabled} validation={validation}/>
        </Box>
    );
}

export default ContactImportTypeDropdown
